import { Tooltip } from '@mui/material';

export const formatDOBAndCalculateAge = (dobString) => {
  if (!dobString) return { age: '', formattedDOB: '' };

  const dob = new Date(dobString);
  if (isNaN(dob)) return { age: '', formattedDOB: '' };

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  const formattedDOB = dob.toLocaleDateString('en-GB');
  const [dd, mm, yyyy] = formattedDOB.split('/');
  return { age, formattedDOB: `${dd}-${mm}-${yyyy}` };
};

const getStatus = (expiryDate) => {
  if (!expiryDate) return { label: 'Unknown', color: '#999' };

  const today = new Date();
  const expiry = new Date(expiryDate);
  const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return { label: 'Expired', color: '#ff4d4f' };
  if (diffDays <= 30) return { label: 'Expiring Soon', color: '#faad14' };
  return { label: 'Active', color: '#52c41a' };
};

export const ExpiryStatusTag = ({ expiryDate }) => {
  const { label, color } = getStatus(expiryDate);

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '12px',
        backgroundColor: color,
        color: '#fff',
        fontSize: '12px',
        fontWeight: 500,
        alignSelf: 'center'
      }}
    >
      {label}
    </span>
  );
};

export const truncateString = (str, charLength, name) => {
  if (!str) return;
  else if (str.length <= charLength)
    return (
      <span style={{ fontSize: '14px' }} className="capitalize">
        {str ? str : name}
      </span>
    );
  else {
    const newString = str.substring(0, charLength) + '...';
    return (
      <Tooltip title={str} placement="left" arrow>
        <span style={{ fontSize: '14px' }} className="capitalize">
          {newString ? newString.toLowerCase() : name}
        </span>
      </Tooltip>
    );
  }
};

export const isAdmissionBeforeDischarge = (admission, discharge) => {
  if (!admission || !discharge) return true;
  return new Date(admission) <= new Date(discharge);
};
